export enum ConsultationFileType {
  Transcript = 1,
  Audio = 2,
}
